import WishlistModalMobile from './components/WishlistModalMobile.js';
import WishlistModalDesktop from './components/WishlistModalDesktop.js';
import 'component?js-wishlist-button';

export default class {
  constructor({ prid, catalog, offer }) {
    this._prid = prid;
    this._catalog = catalog;
    this._offer = offer;
  }
  get prid() {
    return this._prid;
  }
  get catalog() {
    return this._catalog;
  }
  get offer() {
    return this._offer;
  }
  show() {
    const modal = new (IS_MOBILE ? WishlistModalMobile : WishlistModalDesktop)(); // conditional compilation between implementations
    if (IS_MOBILE) {
      document.body.appendChild(modal.el);
    }
    return modal.show({
      prid: this.prid,
      catalog: this.catalog,
      offer: this.offer,
    });
  }
}
